import React, { useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { Link } from "react-router-dom";
import logo from "../../src/assets/images/newlogo.png";
import { useLanguage } from "./hooks/LanguageContext";
import ProductsOld from "../pages/Products";
import Login from "../pages/auth/Login";
import User from "../pages/user/User";
import Home from "../pages/home/Home";
import GeoMap from "../pages/geo/GeoMap";
import HomeIT from "../pages/temporary/HomeIT";
import "flag-icons/css/flag-icons.min.css";

function Navbar() {
    const { user } = useAuth();
    const collapseRef = useRef(null);
    const { language, toggleLanguage } = useLanguage();

    const handleLinkClick = () => {
        const collapseEl = collapseRef.current;
        if (collapseEl && collapseEl.classList.contains("show")) {
            const collapse = new window.bootstrap.Collapse(collapseEl, { toggle: false });
            collapse.hide();
        }
    };

    return (
        <section className="menu menu3 cid-uB0Fiz7sey" id="menu03-0">
            <nav id={Navbar.identifier} className="navbar navbar-dropdown navbar-fixed-top navbar-expand-lg">
                <div className="container">
                    <div className="navbar-brand">
                        <span className="navbar-logo">
                            <Link to={Home.link}>
                                <img src={logo} alt="Логотип" style={{ height: "5rem" }} />
                            </Link>
                        </span>
                    </div>

                    <button
                        className="navbar-toggler"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <div className="hamburger"><span></span><span></span><span></span><span></span></div>
                    </button>

                    <div className="collapse navbar-collapse" ref={collapseRef} id="navbarSupportedContent">
                        <ul className="navbar-nav nav-dropdown nav-right" data-app-modern-menu="true">
                            <li className="nav-item">
                                <Link className="nav-link link show mbr-fonts-style text-primary display-7" onClick={handleLinkClick} to={Home.link}>
                                    {language === "ru" ? "Главная" : "Home"}
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link link show mbr-fonts-style text-primary display-7" onClick={handleLinkClick} to={GeoMap.link}>
                                    {language === "ru" ? "Карта" : "Map"}
                                </Link>
                            </li>
                            {/*<li className="nav-item">*/}
                            {/*    <Link className="nav-link link show mbr-fonts-style text-primary display-7" onClick={handleLinkClick} to={ProductsOld.link}>*/}
                            {/*        {language === "ru" ? "Товары" : "Products"}*/}
                            {/*    </Link>*/}
                            {/*</li>*/}
                            {/*<li className="nav-item">*/}
                            {/*    <Link className="nav-link link show mbr-fonts-style text-primary display-7" onClick={handleLinkClick} to={HomeIT.link}>*/}
                            {/*        {language === "ru" ? "Услуги" : "Services"}*/}
                            {/*    </Link>*/}
                            {/*</li>*/}
                        </ul>

                        <div className="icons-menu d-flex align-items-center ms-auto">
                            {user ? (
                                <Link className="iconfont-wrapper" onClick={handleLinkClick} to={User.link}>
                                    <span className="p-2 mbr-iconfont mobi-mbri-user-2 mobi-mbri"></span>
                                </Link>
                            ) : (
                                <Link className="iconfont-wrapper" onClick={handleLinkClick} to={Login.link}>
                                    <span className="p-2 mbr-iconfont mobi-mbri-user mobi-mbri"></span>
                                </Link>
                            )}

                            {/* Кнопка переключения языка с флагами */}
                            <button
                                onClick={toggleLanguage}
                                className="iconfont-wrapper btn btn-link p-2"
                                style={{
                                    fontSize: "1.5rem",
                                    border: "none",
                                    background: "none",
                                    cursor: "pointer",
                                    padding: "0.5rem",
                                    textDecoration: "none",
                                }}
                                title={language === "ru" ? "Switch to English" : "Переключить на русский"}
                            >
                                {language === "ru" ? (
                                        <span className="fi fi-ru"></span>
                                    ) : (
                                        <span className="fi fi-us"></span>
                                    )}
                            </button>
                        </div>
                    </div>
                </div>
            </nav>
        </section>
    );
}

Navbar.identifier = "app-nav-bar";

export default Navbar;